// @flow strict

import styled from 'styled-components';

import { LegacyTheme, InputField } from 'components/_ReactUI_V1';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    padding: 0px 24px 24px 24px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;

    padding: 0px 24px 31px 24px;

    border-bottom: 1px solid ${LegacyTheme.defaultBuildingBlockBackground};
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    padding: 16px 24px 0px;
    margin-bottom: -4px;

    button + button {
        margin-left: 16px;
    }
`;

export const Field = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    & + & {
        margin-top: 31px;
    }
`;

export const Label = styled.label`
    font-size: 16px;
    line-height: 17px;
    color: ${LegacyTheme.defaultColor};
`;

export const InputNameField = styled(InputField)`
    height: 30px;
    width: 170px;
    border: 1px solid ${LegacyTheme.defaultBorder};
    border-radius: 4px;
    background-color: ${LegacyTheme.disabledBorder};
    margin-left: 8px;
    font-size: 16px;
`;
